/* eslint-disable no-console */
// We're only saving the portion of the url AFTER springswindowfashions/
const getTruncatedWidenUrl = (url) => {
  if (url.indexOf('springswindowfashions/') !== -1) {
    return url.split('springswindowfashions/')[1];
  }
  return url;
};

const getDimensionsFromAssetUrl = (url) => {
  // Returns object w/ width/height or null... should be at position 6 in array
  const a = url.split('/');
  if (a[6] !== undefined) {
    if (a[6].indexOf('px') !== -1 && !isNaN(parseInt(a[6], 10))) {
      const b = a[6].split('x');
      return {
        width: parseInt(b[0], 10),
        height: parseInt(b[1], 10),
      };
    }
  }
  return null;
};

const updateAssetUrlDimensions = (asset) => {
  const urlDims = getDimensionsFromAssetUrl(asset.src);
  if (urlDims !== null) {
    return asset.src
      .replace(`${urlDims.width}x`, `${asset.width}x`)
      .replace(`${urlDims.height}px`, `${asset.height}px`);
  }
  return asset.src;
};

const getIdFromAssetUrl = (url) => {
  const fragment = url.match(/springswindowfashions\/(.*?)\//);
  if (fragment !== null) {
    return fragment[1];
  }
  return url;
};

const getFilename = (filename) => {
  const name = filename;
  if (name.indexOf('.') !== -1) {
    return name.substr(0, name.lastIndexOf('.'));
  }
  return name;
};

const getUrlForWidth = (filename, id, width) => {
  const name = getFilename(filename).replace(/\s/g, '%20');
  return `https://embed.widencdn.net/img/springswindowfashions/${id}/${width}px/${name}.webp`;
};

export {
  getIdFromAssetUrl,
  getTruncatedWidenUrl,
  updateAssetUrlDimensions,
  getFilename,
  getUrlForWidth,
};
/* eslint-enable no-console */
